/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';

import { CacheService } from '../../../global/ng2-cache/services/cache.service';
import { SessionService } from '../../../services/session2.service';
import { AdminService } from '../../../services/admin.service';
import { ErrorService } from '../../../services/error.service';
import { WorkflowService } from '../../../services/workflow.service';
import { GlobalMessageService } from '../../../services/global-message.service';

import { ConfirmDialogComponent } from '../../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-workflow-history',
  templateUrl: './workflow-history.component.html'
})
export class WorkflowHistoryComponent implements OnInit {

  loadingPage = true;
  id: string = '';

  workflow: any = {};
  workflowHistory: any[] = [];

  count: number = 100;
  status: number = -1;

  metricSummary:any = {
    totalEmails: 0,
    addedToList: 0,
    alerts: 0,
    newContacts: 0,
    updatedContacts: 0
  };

  constructor(private route: ActivatedRoute,
              private cacheService: CacheService,
              private sessionService: SessionService,
              private adminService: AdminService,
              private errorService: ErrorService,
              private modalService: BsModalService,
              private workflowService: WorkflowService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        if (!this.cacheService.get('session')) {
          this.sessionService.getSession(true).subscribe(
            (session: any) => {
              this.initView();
            }
          )
        }
        else {
          this.initView();
        }
      }
    )
  }

  refresh() {
    this.initView();
  }

  resetBatch(batch) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Please confirm you would like to re-run this batch`,
        confirm: function() {
          me.adminService.resetWorkflowBatch(batch._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Batch was reset');
              batch.status=0;
              batch.retries = 0;
            },
            err => {
              me.globalMessageService.error();
              me.errorService.log(err, 'workflow-history.component', 'resetBatch');
            });
        }
      }
    }));
  }

  showDetail(batch) {
    if (!batch.show_detail && batch.requestId && batch.requestId.length > 0) {
      this.adminService.getIntegrationLog(batch.requestId).subscribe(
        (result: any) => {
          batch.integrationLog = result || [];
          batch.integrationLog.sort((a,b) => {
            let ad = new Date(a.created_at);
            let bd = new Date(b.created_at);
            if (ad > bd) {
              return 1;
            }
            else {
              return -1;
            }
          });
          batch.show_detail = !batch.show_detail;
        }
      )
    }
    else {
      batch.show_detail = !batch.show_detail;
    }
  }

  private initView() {
    this.loadingPage = true;

    Observable.forkJoin(
      this.workflowService.getWorkflow(this.id),
      this.adminService.getWorkflowBatches(this.id, this.count, this.status)
    ).subscribe(
      (result: any) => {
        this.workflow = result[0];
        this.workflowHistory = result[1];
        this.workflowHistory.forEach((wfh) => {
          this.metricSummary.totalEmails += wfh.emails.length || 0;
          this.metricSummary.addedToList += wfh.metrics.added_to_list || 0;
          this.metricSummary.alerts += wfh.metrics.alerts || 0;
          this.metricSummary.newContacts += wfh.metrics.new_leads || 0;
          this.metricSummary.updatedContacts += wfh.metrics.updated_leads || 0;
          wfh.show_detail = false;
        });
        this.loadingPage = false;
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/config/workflows/workflow-history/workflow-history.component.ts